import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { StringRequest } from "../../../siteadmin/school-type-setup/shared/StringRequest";
import { MeritInsertRequest } from "./MeritInsertRequest";
import { MeritUpdateRequest } from "./MeritUpdateRequest";

@Injectable()
export class DataService_PBISSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadMerits(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/MeritSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MeritCodeInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/MeritCodeInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MeritDescInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/MeritDescInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MeritInsert(parms: MeritInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/MeritInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MeritUpdate(parms: MeritUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/MeritUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ToggleMerit(MeritID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/ToggleMerit?MeritID=" + MeritID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
